import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import Styles from "./Styles.module.css";
import { MdExpandMore } from "react-icons/md";
import Swal from "sweetalert2";
import { getFaq, deleteFaqs } from "Services/ServiceRequest";
import Loader from "Components/Loader/Loader";
import swal from "sweetalert";
import Add from "./Add";
import { useNavigate } from "react-router";
function Page() {
    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState(null);
    const navigate = useNavigate();
    const [Modal, setModal] = useState(false);
    const [subload, setSubLoad] = useState(false);
    const GetRequests = async () => {
        try {
            const response = await getFaq();
            setLoading(false);
            if (response?.data?.Status === 1) {
                setData(
                    response?.data?.FAQs?.map((item) => ({
                        ...item,
                        Expanded: false,
                    }))
                );
            } else {
            }
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };
    useEffect(() => {
        GetRequests();
    }, []);
    const expandHandler = (e, id) => {
        // console.log(id);
        setData((prev) =>
            prev.map((item) =>
                item.FAQId != id
                    ? { ...item, Expanded: false }
                    : { ...item, Expanded: !item.Expanded }
            )
        );
    };
    const DeleteQuestion = async (id) => {
        setSubLoad(true);
        try {
            const response = await deleteFaqs(id);
            setSubLoad(false);
            if (response?.data?.Status === 1) {
                setData((prev) => prev.filter((item) => item.FAQId != id));
            } else {
            }
        } catch (err) {
            setSubLoad(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };
    const deleteHandler = (e, id) => {
        e.stopPropagation();
        swal(`Are You sure you want to Delete FAQ?`, {
            icon: "warning",
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Logout",
                    className: "Delete",
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Logout":
                    DeleteQuestion(id);
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    return (
        <Layout Active={"FAQ"}>
            <Add
                GetRequests={GetRequests}
                edit={edit}
                setEdit={setEdit}
                setModal={setModal}
                showModal={Modal}
                setSubLoad={setSubLoad}
            />
            <div className={Styles["Container"]}>
                <h3>
                    FAQ{" "}
                    <button
                        className={Styles["Add_questions"]}
                        onClick={() => navigate("/faq/add")}>
                        Add
                    </button>
                </h3>
                <Loader loading={loading}>
                    <div className={Styles["Accord_wrapper"]}>
                        {data.length > 0
                            ? data?.map((item, index) => (
                                  <div
                                      className={Styles["Accord"]}
                                      onClick={(e) =>
                                          expandHandler(e, item.FAQId)
                                      }>
                                      <div className={Styles["Label"]}>
                                          <div>
                                              {index + 1}. {item.question["en"]}
                                              <div
                                                  className={
                                                      Styles["Action_btn"]
                                                  }>
                                                  <button
                                                      onClick={(e) =>
                                                          navigate(
                                                              "/faq/edit",
                                                              { state: item }
                                                          )
                                                      }>
                                                      Edit
                                                  </button>
                                                  <button
                                                      onClick={(e) =>
                                                          deleteHandler(
                                                              e,
                                                              item.FAQId
                                                          )
                                                      }>
                                                      Delete
                                                  </button>
                                              </div>
                                          </div>
                                          <MdExpandMore size={23} />
                                      </div>
                                      <p
                                          className={
                                              item.Expanded
                                                  ? Styles["show"]
                                                  : Styles["hidden"]
                                          }>
                                          {item?.answer["en"]}
                                      </p>
                                  </div>
                              ))
                            : "No Questions Found"}
                    </div>
                </Loader>
            </div>
        </Layout>
    );
}

export default Page;
